package gr.tech.GRAttestation.util

import kotlinx.datetime.*

val todayString: String = Clock.System.now()
    .toLocalDateTime(TimeZone.currentSystemDefault())
    .date.toString()  // ISO-8601, so "YYYY-MM-DD"

object TimeUtils {
    fun getMyLocalDateTimeNow(): LocalDateTime {
        return Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
    }

    fun getMyMonth(): String {
        return Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).month.name
            .lowercase().replaceFirstChar { it.uppercase() }
    }

    fun formatDateOnly(isoDateTime: String): String {
        return try {
            val instant = LocalDateTime.parse(isoDateTime).toInstant(TimeZone.currentSystemDefault())
            val date = instant.toLocalDateTime(TimeZone.currentSystemDefault()).date
            "${pad(date.monthNumber)}/${pad(date.dayOfMonth)}/${date.year}"
        } catch (e: Exception) {
            ""
        }
    }

    fun formatDateTime(isoDateTime: String): String {
        return try {
            val dateTime = LocalDateTime.parse(isoDateTime)
            val hour12 = if (dateTime.hour % 12 == 0) 12 else dateTime.hour % 12
            val amPm = if (dateTime.hour < 12) "AM" else "PM"
            val minute = pad(dateTime.minute)
            "${pad(dateTime.monthNumber)}/${pad(dateTime.dayOfMonth)}/${dateTime.year} $hour12:$minute $amPm"
        } catch (e: Exception) {
            ""
        }
    }

    // Will default time to beginning of day.
    fun parseHtmlDateInput(dateString: String): LocalDateTime? {
        return try {
            val parts = dateString.split("-")
            if (parts.size != 3) throw IllegalArgumentException("Expected format yyyy-MM-dd")
            val year = parts[0].toInt()
            val month = parts[1].toInt()
            val day = parts[2].toInt()
            LocalDateTime(year, month, day, 0, 0)
        } catch (e: Exception) {
            console.error("Invalid date input: $dateString", e)
            null
        }
    }

    private fun pad(n: Int): String = n.toString().padStart(2, '0')
}

